<div class="inbuilt-stat-card">
  <!-- <h3 class="card-title">{{ cardTitle }}</h3> -->
  @if (loading) {
  <div class="loading-indicator">
    <mat-spinner diameter="36"></mat-spinner>
  </div>
  }

  <div class="stats-grid" [style.grid-template-columns]="gridTemplateColumns">
    @for (group of statGroups; track group) {
    <div class="stat-group">
      <div class="stat-item">
        <p class="stat-title">{{ group.primary.title }}</p>
        <p class="stat-value">{{ group.primary.formattedValue }}</p>
      </div>
      @if (group.secondary) {
      <div class="stat-item secondary-item">
        <p class="stat-title">{{ group.secondary.title }}</p>
        <p class="stat-value">{{ group.secondary.formattedValue }}</p>
      </div>
      }
    </div>
    }
  </div>
</div>
